import type * as React from 'react'

function DenmarkFlag(props: React.SVGProps<SVGSVGElement>) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: ignore existing biome errors
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22.2026 19.8621H1.79742C0.804703 19.8621 0 19.0574 0 18.0646V5.93536C0 4.94269 0.804703 4.13794 1.79742 4.13794H22.2026C23.1952 4.13794 24 4.94264 24 5.93536V18.0647C24 19.0574 23.1953 19.8621 22.2026 19.8621Z"
        fill="#C60C30"
      />
      <path d="M24 10.7586H9.93103V4.13794H7.4483V10.7586H0V13.2414H7.4483V19.8621H9.93103V13.2414H24V10.7586Z" fill="#ffffff" />
    </svg>
  )
}

export default DenmarkFlag
